import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { C, EASE, SECTIONS } from "./theme";
import { IntroPage } from "./Feature";
import { Itinerary } from "./Itinerary";
import { useIsDesktop } from "./hooks";

const LEATHER = `radial-gradient(ellipse at 50% 40%, ${C.rich} 0%, ${C.burgundy} 55%, ${C.wine} 100%)`;
const EDGES = `0 2px 0 #EFE4DA, 0 4px 0 #E6D8CB, 0 6px 0 #DCCBBB, 0 8px 0 #D2BFAE, 0 40px 80px rgba(20,0,4,0.55)`;

function MobileItinerary() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-25% 0px" });
  return <div ref={ref} className="relative min-h-[680px] pp-paper"><Itinerary stamped={inView} sections={SECTIONS} /></div>;
}

export function IssueCover() {
  const desktop = useIsDesktop();
  const [ready, setReady] = useState(false);
  const [stamped, setStamped] = useState(false);
  useEffect(() => {
    const a = setTimeout(() => setReady(true), 3300);
    const b = setTimeout(() => setStamped(true), 4400);
    return () => { clearTimeout(a); clearTimeout(b); };
  }, []);

  return (
    <>
      <section id="contents" data-testid="issue-landing" className="relative min-h-screen lg:h-screen lg:min-h-[640px] overflow-hidden pt-[84px] md:pt-[92px] pb-5 md:pb-8 px-3 md:px-[3vw]" style={{ background: LEATHER, perspective: 2400 }}>
        <div className="absolute inset-0 opacity-[0.2] mix-blend-overlay pointer-events-none" style={{ backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='l'><feTurbulence type='fractalNoise' baseFrequency='1.2' numOctaves='3'/></filter><rect width='200' height='200' filter='url(%23l)'/></svg>\")" }} />
        <motion.div
          initial={{ y: 40, opacity: 0, rotateX: 8 }}
          animate={ready ? { y: 0, opacity: 1, rotateX: 0 } : {}}
          transition={{ duration: 1.2, ease: EASE }}
          className="relative lg:h-full grid lg:grid-cols-2 rounded-[14px]"
          style={{ boxShadow: EDGES }}
          data-testid="issue-spread"
        >
          <div className="relative overflow-hidden rounded-[14px] lg:rounded-r-none pp-paper"><IntroPage /></div>
          {desktop && (
            <div className="relative overflow-hidden rounded-r-[14px] pp-paper">
              <Itinerary stamped={stamped} sections={SECTIONS} />
            </div>
          )}
          {desktop && <div className="absolute top-0 bottom-0 left-1/2 w-24 -ml-12 pointer-events-none z-[7]" style={{ background: `linear-gradient(90deg, transparent, ${C.wine}1a 45%, ${C.wine}2e 50%, ${C.wine}1a 55%, transparent)` }} />}
        </motion.div>
      </section>
      {!desktop && (
        <section data-testid="mobile-contents" className="relative" style={{ background: C.warm }}>
          <MobileItinerary />
        </section>
      )}
    </>
  );
}
